import React from 'react';
import { Card, Input, Switch, Button, Typography, Empty } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import ExerciseItemCard from './ExerciseItemCard';
import { useI18n } from 'hooks/useI18n';

const { Text } = Typography;

const DayEditor = ({ day, onToggleRest, onTitleChange, onItemChange, onItemRemove, onAddExercise }) => {
	const { t } = useI18n();
	if (!day) {
		return (
			<Card className="template-builder-day-editor template-builder-day-editor--empty" bordered={false}>
				<Empty description={t('workouts.template.day_editor.select_day_to_edit')} />
			</Card>
		);
	}

	return (
		<Card
			bordered={false}
			className={`template-builder-day-editor${day.isRestDay ? ' template-builder-day-editor--rest' : ''}`}
			title={
				<span className="template-builder-day-editor__title-wrap">
					<Text strong className="template-builder-day-editor__title">{t('workouts.common.day_label', { number: day.dayNumber })}</Text>
					<Input
						className="template-builder-day-editor__title-input"
						size="small"
						value={day.title}
						onChange={(e) => onTitleChange(e.target.value)}
						placeholder={t('workouts.template.day_editor.day_title_optional')}
					/>
				</span>
			}
			extra={
				<span className="template-builder-day-editor__extra">
					<Text type="secondary" className="template-builder-day-editor__extra-label">{t('workouts.template.preview.rest_day')}</Text>
					<Switch checked={day.isRestDay} onChange={onToggleRest} size="small" />
				</span>
			}
		>
			{day.isRestDay ? (
				<div className="template-builder-day-editor__rest-copy">
					{t('workouts.template.day_editor.rest_day_copy')}
				</div>
			) : (
				<>
					<div className="template-builder-day-editor__items">
						{(day.items || []).length === 0 ? (
							<Empty className="template-builder-day-editor__empty-state" description={t('workouts.template.day_editor.no_exercises_yet')} />
						) : (
							day.items.map((item, index) => (
								<ExerciseItemCard
									key={item._id || index}
									item={item}
									index={index}
									onChange={onItemChange}
									onRemove={onItemRemove}
								/>
							))
						)}
					</div>
					<Button className="template-builder-day-editor__add-btn" type="dashed" block icon={<PlusOutlined />} onClick={onAddExercise}>
						{t('workouts.list.add_exercise')}
					</Button>
				</>
			)}
		</Card>
	);
};

export default DayEditor;
